import { render, staticRenderFns } from "./referenzen-kunden-2.vue?vue&type=template&id=0b75716b&"
import script from "./referenzen-kunden-2.vue?vue&type=script&lang=js&"
export * from "./referenzen-kunden-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports